import { useFormik } from 'formik'
import { FC, useMemo } from 'react'
import {
  ButtonType,
  OptionsHelper,
  showAlert,
  showError,
} from '../../../../../../../_metronic/helpers'
import {
  Button,
  FormInput,
  FormSelect,
  IOption,
  LoadingIndicator,
  useModal,
} from '../../../../../../components'
import { useT } from '_metronic/i18n/Metronici18n'
import { gerarFaturaSchema } from './validation/gerarFaturaSchema'
import { GeraFaturaDto } from '../../../atendimentos-nao-faturados/core/_models'
import { gerarFatura } from '../../../atendimentos-nao-faturados/core/_requests'

export const GerarFaturaForm: FC = () => {
  const { t } = useT()
  const { closeModal } = useModal()

  const formik = useFormik({
    initialValues: {
      empresa: undefined as IOption<number> | undefined,
      especialidade: undefined as IOption<number> | undefined,
      unidade: undefined as IOption<number> | undefined,
      ano: undefined as IOption<number> | undefined,
      mes: undefined as IOption<string> | undefined,
      descricao: '',
    },
    validationSchema: useMemo(() => gerarFaturaSchema(t), [t]),
    onSubmit: async (values, { setSubmitting }) => {
      setSubmitting(true)
      try {
        const data: GeraFaturaDto = {
          ano: values.ano?.value as number,
          mes: Number(values.mes?.value),
          atendimentos: null,
          descricao: values.descricao,
          especialidade: values.especialidade?.value,
          unidade: values.unidade?.value,
        }
        await gerarFatura(values.empresa?.value as number, data)
        showAlert({ title: 'Sucesso', text: 'Fatura gerada com sucesso!', icon: 'success' })
        closeModal()
      } catch (error) {
        showError(error)
      } finally {
        setSubmitting(false)
      }
    },
  })

  const extraParams = useMemo(
    () => ({ empresaId: formik.values.empresa?.value }),
    [formik.values.empresa?.value]
  )

  return (
    <form onSubmit={formik.handleSubmit} noValidate>
      <div className='row'>
        <div className='col-lg-6'>
          <FormSelect
            formik={formik}
            name='empresa'
            fetchOptions={OptionsHelper.getOptionsEmpresasForFaturamento}
            entity='empresa'
            className='mb-3'
            isRequired
          />
        </div>
        <div className='col-lg-6'>
          <FormSelect
            formik={formik}
            name='unidade'
            fetchOptions={OptionsHelper.getOptionsUnidades}
            entity='unidade'
            className='mb-3'
            fetchOptionsParams={extraParams}
          />
        </div>
        <div className='col-lg-6'>
          <FormSelect
            formik={formik}
            name='especialidade'
            fetchOptions={OptionsHelper.getOptionsEspecialidades}
            entity='especialidade'
            className='mb-3'
          />
        </div>
        <div className='col-lg-3'>
          <FormSelect
            formik={formik}
            name='mes'
            fetchOptions={OptionsHelper.getOptionsMeses}
            entity='mes'
            className='mb-3'
            isRequired
          />
        </div>
        <div className='col-lg-3'>
          <FormSelect
            formik={formik}
            name='ano'
            entity='ano'
            fetchOptions={OptionsHelper.getOptionsAnos}
            className='mb-3'
            isRequired
          />
        </div>
      </div>
      <FormInput formik={formik} name='descricao' entity='descricao' isRequired />

      <div className='d-flex justify-content-center mt-10'>
        <Button className='btn-secondary me-3' disabled={formik.isSubmitting} onClick={closeModal}>
          {t('common.cancel')}
        </Button>
        <Button type={ButtonType.Submit} className='btn-primary' disabled={formik.isSubmitting}>
          {formik.isSubmitting ? <LoadingIndicator /> : t('common.save')}
        </Button>
      </div>
    </form>
  )
}
